import axios from 'axios'
import { get } from 'lodash'

import { getConfig } from '../../utils'

import { CATEGORY_SUCCESS, CATEGORY_FAILURE, CATEGORY_REQUEST } from './type'

export const getCategory = (locale) => async (dispatch) => {
  if (locale) {
    try {
      dispatch({ type: CATEGORY_REQUEST })
      const lang = locale === 'cn' ? 'zh-CN' : locale
      Promise.all([
        axios.get(`${getConfig('HOST_API')}/quickstart-guides?_locale=${lang}`),
        axios.get(`${getConfig('HOST_API')}/popular-topics?_locale=${lang}`),
      ]).then((values) => {
        const payload = values.map((v) => get(v, 'data', []))
        dispatch({ type: CATEGORY_SUCCESS, payload })
      })
    } catch (err) {
      dispatch({ type: CATEGORY_FAILURE, payload: err.message })
    }
  }
}
